import { useTranslation } from 'react-i18next';
import { createShortUrlAndRedirect } from '../../ultils';
import './MessageModal.scss';

interface ModalProps {
    isFormOpen: boolean;
    setIsFormOpen: (isFormOpen: boolean) => void;
    currentUrlToRedirect: string;
    isReverse: boolean;
}

const MessageModal: React.FC<ModalProps> = ({ isFormOpen, setIsFormOpen, currentUrlToRedirect }) => {

    const { t } = useTranslation();

    const onClose = () => {
        setIsFormOpen(!isFormOpen);
    }

    const LoginbtnHandler = async () => {
        createShortUrlAndRedirect(currentUrlToRedirect, "")
    };

    const RegisterbtnHandler = async () => {
        createShortUrlAndRedirect(currentUrlToRedirect, '/Registration')
    };

    return isFormOpen ? (
        <div className='modal-box height-150'>
            <div className="modal-header-form-custom">
                <div className="modal-title-area">
                    <h3 className="modal-title-form-custom"> {t('xref-add-to-list')} </h3>
                </div>
                <button
                    type="button"
                    className='close-button-form-area'
                    data-dismiss="modal"
                    onClick={onClose}
                >
                    ×
                </button>
            </div>

            <div className="mb-2"> {t('xref-this-feature-is-only-available-for-registered-users-please')}
                <button
                    onClick={LoginbtnHandler}
                    data-testid="login-test-btn"
                    className="link-button "
                    id="login-btn"
                >
                    {t('xref-login-btn')}
                </button>{" "}
                {t('xref-or')}{" "}
                <button
                    onClick={RegisterbtnHandler}
                    data-testid="register-test-btn"
                    className="link-button "
                    id="register-btn"
                >
                    {t('xref-register')}
                </button>

            </div>

            <div className="action-button-container">
                <div className="add-to-list-btn-area ">
                    <button
                        type="submit"
                        className="dk-btn__primary"
                        data-dismiss="modal"
                        onClick={onClose}
                        data-testid="close-test-btn"
                    >
                        {t('xref-ok')}
                    </button>

                </div>
            </div>
        </div>
    ) : null
}

export default MessageModal;